export enum DepositStatusFilter {
  WITH = "with",
  WITHOUT = "without",
}

export const DEPOSIT_STATUS_OPTIONS = [
  { value: DepositStatusFilter.WITH, label: "Com depósito" },
  { value: DepositStatusFilter.WITHOUT, label: "Sem depósito" },
];

export const BALANCE_REPORT_FILTERS_STORAGE_KEY = "balanceReportFilters";
